<template>
    <div class="test">
        <div v-for="(item,index) in data" :key="index">
            <p>	
                {{index+1}}、{{item.question}}
            </p>
            <span v-for="(items,indexs) in item.options" :key="indexs">
                <input type="radio" :disabled="submitStatus" :name="'radio'+index" :value="indexs" v-model="options[index]" :id="'radio'+index+indexs"/>
                <label :for="'radio'+index+indexs">
                        {{items}}
                </label>
            </span>
        </div>
        <button @click="submit">提交</button>
        <span v-if="submitStatus&pass" style="color:#67c23a">恭喜您通过考核</span>
        <span v-if="submitStatus&!pass" style="color:#f56c6c">很遗憾您未通过考核</span>
    </div>
</template>

<script>
import {
  getExamQuestions,
  examine
} from "@/assets/js/axios.js";
export default {
    name: "test",
    data(){
        return{
            data:[],
            options:[],
            submitStatus:false,
            pass:false,
        }
    },
    created(){
        getExamQuestions(this.$route.params.id.substring(0, this.$route.params.id.length - 4))
        .then(res => {
            if(res.code==1){
                this.data=res.data
            }
        })
    },
    methods:{
      
        submit(){
            if(this.submitStatus){
                return
            }
            let obj=[]
            for(let i=0;i<this.options.length;i++){
                if(this.options[i]){
                    obj.push({qid:this.data[i].qid,answer:this.options[i]})
                }
            }
            if(obj.length<this.data.length){
                this.$message({
                    message: '请全部作答完毕再提交',
                    type: 'warning'
                });
                return
            }
            examine(obj).then(res=>{
                if(res.code==1){
                    this.submitStatus=true
                    this.pass=res.data.pass
                    // if(res.data.pass){
                    //     this.$message({
                    //         message: '恭喜您通过考核',
                    //         type: 'success'
                    //     });
                    // }else{
                    //     this.$message({
                    //         message: '很遗憾您未通过考核',
                    //         type: 'error'
                    //     });
                    // }
                }
            })
        }
    }
}
</script>

<style lang="less" scoped>
.test{
    padding:60px 0 40px;
    width: 1200px;
    margin: 0 auto;
    div{
       
        margin: 20px 0;
        line-height: 40px;
        span{
            padding-left:28px;
        }
    }
    button{
        margin: 30px;
        width: 160px;
        height: 40px;
        cursor: pointer;
        background: #109eff;
        border:none;
        color: #fff;
        border-radius: 8px;
        outline: none;
    }
}
</style>


// WEBPACK FOOTER //
// src/components/test.vue